"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextColorMenu = void 0;
var react_1 = __importDefault(require("react"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ColorPalette_1 = __importDefault(require("Common/ColorPalette/ColorPalette"));
var ClientColorProvider_1 = require("DreamCoat/ClientColorProvider");
var styles = __importStar(require("./MenuStyles.css"));
var TextColorMenu = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var colorProvider = (0, ClientColorProvider_1.useColorProvider)();
    var selectedColor = value ? colorProvider.decorateColor(value) : undefined;
    return (react_1.default.createElement(kaleidoscope_1.ToolbarPopover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Small, padding: "small", button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(ColorButton, { selectedColor: selectedColor }), tooltip: { content: "Text color" } }))); }, autoStack: true },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
            react_1.default.createElement(kaleidoscope_1.Label, { theme: "dark", size: "s" }, "Text color"),
            react_1.default.createElement(ColorPalette_1.default, { type: "content", presetColors: colorProvider.filteredThemeColors, onColorChange: onChange, selectedColor: selectedColor, includeColorPanelPicker: true }))));
};
exports.TextColorMenu = TextColorMenu;
var ColorButton = function (_a) {
    var _b;
    var _c;
    var selectedColor = _a.selectedColor;
    var barColour = (_c = selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.value) !== null && _c !== void 0 ? _c : "linear-gradient(90deg, rgba(113,107,241,1) 25%, rgba(11,218,201,1) 50%, rgba(255,206,83,1) 75%, rgba(255,97,97,1) 100%)";
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.textColorIcon, align: "center", justify: "center" },
        react_1.default.createElement(icons_1.TextColor, null),
        react_1.default.createElement("div", { className: styles.textColorBar, style: (0, dynamic_1.assignInlineVars)((_b = {},
                _b[styles.textColorBarBackground] = barColour,
                _b)) })));
};
